import React, { useEffect } from 'react';
import {
  Box,
  Container,
  Divider,
  LinearProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import {
  AKADEMY_USERS_ROUTE,
  AKADEMY_SCHOOL_MEMBERS_ROUTE,
  AKADEMY_SCHOOLS_ROUTE,
  AKADEMY_PROGRAMMES_ROUTE,
  AKADEMY_CLASSES_ROUTE,
  AKADEMY_LANGUAGES_ROUTE,
  AKADEMY_CURRICULUM_FRAMEWORKS_ROUTE,
  AKADEMY_CURRICULUM_NODES_ROUTE,
  AKADEMY_CURRICULUM_AGE_GROUPS_ROUTE,
  AKADEMY_CURRICULUM_RATING_SCALES_ROUTE,
  AKADEMY_CURRICULUM_SUGGESTIONS_ROUTE,
  AKADEMY_INDICATOR_STATUTORIES_ROUTE,
  AKADEMY_STORAGE_PLAN_ROUTE,
  AKADEMY_Token_PLAN_ROUTE,
  AKADEMY_TALKTIME_PLANS_ROUTE,
  AKADEMY_TALKTIME_CONSUMPTION_ROUTE,
  AKADEMY_AI_ASSIST_CONSUMPTION_ROUTE,
  AKADEMY_WIDGET_ROUTE,
  AKADEMY_WIDGET_CUSTOMIZATION_ROUTE,
  AKADEMY_ANALYTICS_ROUTE,
} from '../../routes/routes';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAllAkademyLanguages,
  getAllAkademyProgrammes,
  getAllAkademyClasses,
  getAllAkademySchools,
} from './AkademySlice';
import AkademySideNavBar from './AkademySideNavBar';
import AkademySchools from './Schools/AkademySchools';
import AkademyProgrammes from './Programmes/AkademyProgrammes';
import AkademyLanguages from './Languages/AkademyLanguages';
import AkademyClasses from './Classes/AkademyClasses';
import AkademyUsers from './Users/AkademyUsers';
import AkademySchoolMembers from './SchoolMembers/AkademySchoolMembers';
import AkademyCurriculumFrameworks from './Curriculum/AkademyCurriculumFrameworks';
import AkademyCurriculumNodes from './Curriculum/AkademyCurriculumNodes';
import AkademyCurriculumAgeGroups from './Curriculum/AkademyCurriculumAgeGroups';
import AkademyCurriculumRatingScales from './Curriculum/AkademyCurriculumRatingScales';
import AkademyCurriculumActionSuggestions from './Curriculum/AkademyCurriculumActionSuggestions';
import AkademyIndicatorStatutories from './Framework/AkademyIndicatorStatutories';
import AkademyStoragePlan from './StoragePlan/AkademyStoragePlan';
import AkademyTokenPlan from './TokenPlan/AkademyTokenPlan';
import AkademyTalktimePlans from './Talktime/AkademyTalktimePlans';
import AkademyTalktimeConsumption from './AI_Tracking/AkademyTalktimeConsumption';
import AIAssistConsumption from './AI_Tracking/AIAssistConsumption';
import AkademyWidgetSetup from './Widget/AkademyWidgetSetup';
import AkademyWidgetCustomization from './Widget/AkademyWidgetCustomization';
import AkademyAnalytics from './Analytics/AkademyAnalytics';
// import useToggleSideNav from '../../hooks/useToggleSideNav';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

function Akademy() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { school, widgetConfig } = useSelector(({ akademyReducer }) => {
    return {
      school: akademyReducer.school,
      widgetConfig: akademyReducer.widgetConfig,
    };
  });

  useEffect(() => {
    dispatch(getAllAkademySchools());
    dispatch(getAllAkademyProgrammes());
    dispatch(getAllAkademyClasses());
    dispatch(getAllAkademyLanguages());
  }, []);

  return (
    <Container className={classes.overAll}>
      <Box
        display="flex"
        flexDirection={'column'}
        justifyContent={'center'}
        mt={2}
        py={2}>
        <Typography variant="h4" component="div">
          <Box fontWeight="fontWeightMedium">Akadmy</Box>
        </Typography>
        <Typography variant="subtitle1" color="textSecondary">
          Manage All Akadmy related resources from one place.
        </Typography>
      </Box>
      <Divider />
      {(school.isLoading || widgetConfig.isLoading) && <LinearProgress />}

      <Box display="flex" flex={10}>
        <Box minWidth={300} pt={4}>
          <AkademySideNavBar />
        </Box>
        <Box flex={9} pt={4} maxWidth={1060}>
          <Switch>
            <PrivateRoute
              exact
              path={AKADEMY_SCHOOLS_ROUTE}
              component={AkademySchools}
            />
            <PrivateRoute
              exact
              path={AKADEMY_USERS_ROUTE}
              component={AkademyUsers}
            />
            <PrivateRoute
              exact
              path={AKADEMY_SCHOOL_MEMBERS_ROUTE}
              component={AkademySchoolMembers}
            />
            <PrivateRoute
              exact
              path={AKADEMY_PROGRAMMES_ROUTE}
              component={AkademyProgrammes}
            />
            <PrivateRoute
              exact
              path={AKADEMY_CLASSES_ROUTE}
              component={AkademyClasses}
            />
            <PrivateRoute
              exact
              path={AKADEMY_LANGUAGES_ROUTE}
              component={AkademyLanguages}
            />
            <PrivateRoute
              exact
              path={AKADEMY_STORAGE_PLAN_ROUTE}
              component={AkademyStoragePlan}
            />
            <PrivateRoute
              exact
              path={AKADEMY_Token_PLAN_ROUTE}
              component={AkademyTokenPlan}
            />
            <PrivateRoute
              exact
              path={AKADEMY_TALKTIME_PLANS_ROUTE}
              component={AkademyTalktimePlans}
            />
            <PrivateRoute
              exact
              path={AKADEMY_TALKTIME_CONSUMPTION_ROUTE}
              component={AkademyTalktimeConsumption}
            />
            <PrivateRoute
              exact
              path={AKADEMY_AI_ASSIST_CONSUMPTION_ROUTE}
              component={AIAssistConsumption}
            />
            <PrivateRoute
              exact
              path={AKADEMY_CURRICULUM_FRAMEWORKS_ROUTE}
              component={AkademyCurriculumFrameworks}
            />
            <PrivateRoute
              exact
              path={AKADEMY_CURRICULUM_NODES_ROUTE}
              component={AkademyCurriculumNodes}
            />
            <PrivateRoute
              exact
              path={AKADEMY_CURRICULUM_RATING_SCALES_ROUTE}
              component={AkademyCurriculumRatingScales}
            />
            <PrivateRoute
              exact
              path={AKADEMY_CURRICULUM_AGE_GROUPS_ROUTE}
              component={AkademyCurriculumAgeGroups}
            />
            <PrivateRoute
              exact
              path={AKADEMY_CURRICULUM_SUGGESTIONS_ROUTE}
              component={AkademyCurriculumActionSuggestions}
            />
            <PrivateRoute
              exact
              path={AKADEMY_INDICATOR_STATUTORIES_ROUTE}
              component={AkademyIndicatorStatutories}
            />
            <PrivateRoute
              exact
              path={AKADEMY_WIDGET_ROUTE}
              component={AkademyWidgetSetup}
            />
            <PrivateRoute
              exact
              path={AKADEMY_WIDGET_CUSTOMIZATION_ROUTE}
              component={AkademyWidgetCustomization}
            />
            <PrivateRoute
              exact
              path={AKADEMY_ANALYTICS_ROUTE}
              component={AkademyAnalytics}
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}

export default Akademy;
